<!--  -->
<template>
  <div>
    <van-popup v-model="showPop" class="tips">
      <div>
        <h2>重要提醒</h2>
        <h3>检测到您已签署过该的协议，协议同样适用于此门课程，如有疑问请联系客服</h3>
        <div @click="knowBtn">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { resAgreementAlert } from '@/api/personal/myAgreement';

export default {
  components: {},
  data() {
    return {
      showPop: false,
    };
  },
  props: {
    giveAgreementPop: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
    knowBtn() {
      this.showPop = false;
      resAgreementAlert(this.giveAgreementPop?.userAgreementRespVO?.id).then((data) => {

      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tips {
  box-sizing: border-box;
  width: 634px;
  height: 415px;
  padding: 47px 48px;
  background: #fff;
  border-radius: 14px;
  > div {
    h2 {
      padding-bottom: 47px;
      color: #000;
      font-weight: 500;
      font-size: 33px;
      line-height: 45px;
      text-align: center;
    }
    h3 {
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
      text-align: center;
    }
    > div {
      width: 326px;
      height: 80px;
      margin: 43px auto 10px auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff6c02;
      border-radius: 40px;
    }
  }
}
::v-deep .van-overlay,::v-deep .van-popup--center{
    z-index: 1000000 !important;
  }
</style>
